<template>
    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addEditOffer></addEditOffer>




    </v-dialog>
</template>

<script>
    import addEditOffer from '../Shared/AddOffer.vue'

    // Settings Types
    import {
        Offer
    } from '../../store/namespace-helper'

    export default {
      name: 'offer-dialog',
      components: {
        addEditOffer
      },
      data () {
        return {
        }
      },
      methods: {
      },
      computed: {
        dialog () {
          return this.$store.getters[Offer.getters.getOpenDialogState]
        }
      },
      beforeDestroy () {

      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Offers/AddOfferDialog.vue